import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { FormattedMessage } from 'react-intl';
import Ruler from 'dibs-vg/dist/react/ruler';

import styles from './ProductTileMeasurements.scss';

const ProductTileMeasurementsComponent = ({ item, measurementUnit, isMobile }) => {
    const measurement = get(item, 'measurement');
    const size = get(measurement, 'size') || {};
    const dimensionValues = (get(measurement, 'display') || [])
        .filter(({ unit }) => (unit ? unit === measurementUnit : true))
        .map(dimension => dimension.value);

    return size.value ? (
        <FormattedMessage
            id="dc.searchProductTile.sizeLabel"
            defaultMessage="Size: {size}"
            values={{
                size: size.value,
            }}
        />
    ) : (
        <React.Fragment>
            {!isMobile && dimensionValues[0] && <Ruler className={styles.rulerIcon} />}
            {dimensionValues[0]}
        </React.Fragment>
    );
};

ProductTileMeasurementsComponent.propTypes = {
    item: PropTypes.object,
    measurementUnit: PropTypes.string,
    isMobile: PropTypes.bool,
};

export const ProductTileMeasurements = createFragmentContainer(ProductTileMeasurementsComponent, {
    item: graphql`
        fragment ProductTileMeasurements_item on Item {
            measurement {
                display(addLabel: true, separator: " ", fields: [height, width, depth, diameter]) {
                    unit
                    value
                }
                size {
                    value
                }
            }
        }
    `,
});
